import { Button, Space } from '@/components';
import {
  type AnalysisSearchFormType,
  AnalysisSearchSchema,
  initialValueOfAnalysisSearchForm,
} from '@/features/search/_models/analysis-search';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCurrentFiscalYear } from '../../_hooks/get-current-fiscal-year';

export const SearchButton: FC<{
  formId: string;
  onResetPayment: () => void;
}> = ({ formId, onResetPayment }) => {
  const { t } = useTranslation();
  const { reset } = useFormContext<AnalysisSearchFormType>();
  const currentFiscalYear = useCurrentFiscalYear();
  const initialValue = initialValueOfAnalysisSearchForm(
    currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
  );
  return (
    <Space>
      <Button
        htmlType="button"
        type="default"
        onClick={async () => {
          const nullifiedValues = Object.keys(
            AnalysisSearchSchema.shape,
          ).reduce(
            (acc, key) => {
              acc[key] = null;
              return acc;
            },
            {} as Record<string, null>,
          );
          reset({
            ...nullifiedValues,
            ...initialValue,
            fiscalYearRange: [
              dayjs().year(initialValue.fiscalYearRange[0] ?? 0),
              dayjs().year(initialValue.fiscalYearRange[1] ?? 0),
            ],
          });
          onResetPayment();
        }}
      >
        {t('search-clear')}
      </Button>
      <Button form={formId} htmlType="submit" type="primary">
        {t('search-by')}
      </Button>
    </Space>
  );
};
